import React, { useState } from "react";
import PageHero from "../../components/PageHero";
import Pagination from "../../components/Pagination";

export default function Photos({ siteContent }) {
  const [activeIndex, setActiveIndex] = useState(null);
  const { title, headContent, image, images } = siteContent

  const allPhotos = images
  const perPage = 9;
  const totalPages = Math.ceil(allPhotos.length / perPage);

  const [page, setPage] = useState(1);

  const start = (page - 1) * perPage;
  const items = allPhotos.slice(start, start + perPage);

  const open = (index) => setActiveIndex(index);
  const close = () => setActiveIndex(null);

  const next = () => setActiveIndex((prev) => (prev + 1) % images.length);

  const prev = () => setActiveIndex((prev) => prev === 0 ? images.length - 1 : prev - 1);

  return (
    <>
      <PageHero
        title={title}
        subtitle={headContent}
        img={image?.url}
      />

      <main className="container main">
        <section className="section">
          <div className="gallery">
            {items.map((p, i) => (
              <button key={p.id} className="gcard" onClick={() => open(i)} type="button">
                <img className="gcard__img" src={p.nameFile} alt={p.title} loading="lazy" />
                <div className="gcard__caption">{p.title}</div>
              </button>
            ))}
          </div>

          <Pagination page={page} totalPages={totalPages} onChange={setPage} />
        </section>
      </main>
      {activeIndex !== null && (
        <div className="lightbox" onClick={close}>
          <button className="lightbox__close">✕</button>

          <img
            src={allPhotos[activeIndex].nameFile}
            className="lightbox__image"
            alt={activeIndex}
            onClick={(e) => e.stopPropagation()}
          />
          {allPhotos[activeIndex].title && (
            <span className="newsGallery__caption">{allPhotos[activeIndex].title}</span>
          )}

          <button className="lightbox__prev" onClick={(e) => { e.stopPropagation(); prev(); }}>
            ‹
          </button>

          <button className="lightbox__next" onClick={(e) => { e.stopPropagation(); next(); }}>
            ›
          </button>
        </div>
      )}
    </>
  );
}